import { type CanDeactivateFn } from '@angular/router';

import { type StorageLocationsPage } from './storage-locations';

// Kept separate from the page so route configuration does not load it eagerly.
export const canLeaveStorageLocations: CanDeactivateFn<StorageLocationsPage> = (page) =>
  page.canDeactivate();
